import React from 'react';
import { View, StyleSheet, Image, Dimensions } from 'react-native';
import CustomText from '../../components/customText/CustomText';
import MessageListWebMobile from '../../components/messageListWebMobile';
import MessageList from '../../components/messageList';
import ToggleButton from '../../components/toggleButton';
import MessageDetail from '../../components/messageDetail';
import theme from '../../constants/theme.style.js';
import InboxHeader from '../../components/inboxHeader/InboxHeader';

const turtleNoMessageSelected = require('../../assets/Turtles/main-turtle.png');

const { width } = Dimensions.get('window');

let styles;
if (width > 800) {
  styles = StyleSheet.create({
    inboxContainer: {
      backgroundColor: theme.WHITE_COLOR,
      display: 'flex',
      flexDirection: 'row',
    },
    left: {
      shadowColor: theme.GREY_MEDIUM_COLOR,
      shadowRadius: 20,
      shadowOpacity: 1,
      borderColor: 'white',
      zIndex: 40,
    },
    right: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '60vw',
      backgroundColor: theme.GREY_LIGHT_COLOR,
    },
    turtleNoMessageSelected: {
      width: 250,
      height: 220,
      marginBottom: theme.CONTAINER_MARGIN,
    },
  });
} else {
  styles = StyleSheet.create({
    container: {
      flex: 1,
      width: '100%',
      height: '100%',
      backgroundColor: theme.GREEN_DARKER_COLOR,
    },
    body: {
      flex: 1,
      backgroundColor: theme.WHITE_COLOR,
      borderTopLeftRadius: 30,
      borderTopRightRadius: 30,
      paddingTop: 10,
    },
  });
}

export default class Inbox extends React.Component {
  static navigationOptions = {
    title: 'Turtlets',
    headerShown: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      messageClickedId: null,
      isInboxActive: true,
      isInbox: true,
      isInboxShownInDetail: true,
    };
  }

  callback = (id) => {
    const { isInboxActive } = this.state;
    this.setState({
      messageClickedId: id,
      isInboxShownInDetail: isInboxActive,
    });
  };

  callback2 = (userChoice) => {
    this.setState({
      isInboxActive: userChoice === 'Inbox',
    });
  };

  callback3 = (userChoice) => {
    this.setState({
      // eslint-disable-next-line no-unneeded-ternary
      isInbox: userChoice === 'Inbox' ? true : false,
    });
  };

  render() {
    const { messageClickedId, isInboxActive, isInboxShownInDetail, isInbox } = this.state;
    const { navigation } = this.props;

    if (width < 800) {
      return (
        <View style={styles.container}>
          <InboxHeader />
          <View style={styles.body}>
            <ToggleButton textLeft="Inbox" textRight="Outbox" callback={this.callback3} />
            <MessageListWebMobile navigation={navigation} isInbox={isInbox} />
          </View>
        </View>
      );
    }
    return (
      <View style={styles.inboxContainer}>
        <View style={styles.left}>
          <ToggleButton textLeft="Inbox" textRight="Outbox" callback={this.callback2} />
          <MessageList
            callback={this.callback}
            active={messageClickedId}
            isInbox={isInboxActive}
            navigation={navigation}
          />
        </View>
        {messageClickedId !== null && (
          <MessageDetail id={messageClickedId} isInbox={isInboxShownInDetail} />
        )}
        {!messageClickedId !== null && (
          <View style={styles.right}>
            <Image source={turtleNoMessageSelected} style={styles.turtleNoMessageSelected} />
            <CustomText>Select a Turtlet from the Inbox or Outbox to display it here.</CustomText>
          </View>
        )}
      </View>
    );
  }
}
